import { useCallback } from 'react';

import { usePintoEbookCollectionItemsLazyQuery } from '../core/graphql/operation-hooks';
import { PintoEbookCollectionItemsFilter } from '../core/graphql/types';

const INITIAL_LIMIT = 50;

const useQueryPintoEbookCollectionItems = () => {
  const [queryPintoEbookCollectionItems, { data, variables, loading }] = usePintoEbookCollectionItemsLazyQuery({ fetchPolicy: 'network-only' });

  const fetchPintoEbookCollectionItems = useCallback(
    (ebookCollectionId: string, filter?: PintoEbookCollectionItemsFilter) => {
      queryPintoEbookCollectionItems({
        variables: {
          ebookCollectionId,
          filter: {
            ...filter,
            limit: INITIAL_LIMIT,
          },
        },
      });
    },
    [queryPintoEbookCollectionItems],
  );

  const onFetchMorePintoEbookCollectionItems = useCallback(() => {
    if (loading || !data?.pintoEbookCollectionItems?.pageInfo.hasNextPage) return;
    if (!variables?.ebookCollectionId) return;
    fetchPintoEbookCollectionItems(variables.ebookCollectionId, {
      ...variables?.filter,
      offset: data?.pintoEbookCollectionItems?.edges.length,
    });
  }, [
    loading,
    data?.pintoEbookCollectionItems?.pageInfo.hasNextPage,
    data?.pintoEbookCollectionItems?.edges.length,
    fetchPintoEbookCollectionItems,
    variables?.ebookCollectionId,
    variables?.filter,
  ]);

  return {
    fetchPintoEbookCollectionItems,
    onFetchMorePintoEbookCollectionItems,
    pintoEbookCollectionItems: data?.pintoEbookCollectionItems,
    isLoadingPintoEbookCollectionItems: loading,
  };
};

export default useQueryPintoEbookCollectionItems;
